<template>
	<div>
		<b-card no-body class="p-20">

			<h5 ref="typeOfCar">Pengecekan Kondisi Mobil - Barang , Interior</h5>

			<div class="row mt-1" >
				<div class="col-sm-4 col-lg-2 col-12 label-car-type mt-auto">
					<label>Pilih Jenis Kendaraan :</label>
				</div>
				<div class="col-sm-3 col-lg-2 col-6 mt-auto">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'sedan', 'btn-outline-info' : carTypes != 'sedan'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'sedan'"
							disabled
						>
							Sedan
						</button>
				</div>
				<div class="col-sm-3 col-lg-2 col-6 mt-auto">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'minibus', 'btn-outline-info' : carTypes != 'minibus'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'minibus'"
							disabled
						>
							Minibus
						</button>
				</div>
				<div class="col-sm-12 col-lg-4 offset-lg-2 col-12">
					<label>Tipe Pengecekan</label>
					<Multiselect 
						v-if="keysCheckSettings"
						:options="keysCheckSettings"
						v-model="keySelector"
						:allow-empty="false"
					/>
				</div>
			</div>
		</b-card>

		<!-- {{indexPosition}} -->
		<b-card no-body class="p-20 mt-3" v-if="indexPosition == 7">
			<h5>Pengecekan Telah Selesai!</h5>
		</b-card>

		<b-card no-body class="p-20 mt-3" v-for="checklist in checkSettingsFormatted[keysCheckSettings[indexPosition]]" style="background-color:#d9e0e7">
			<div class="mt-3" v-if="checkSettingsFormatted">
				<!-- <h5>Tipe Pengecekan : {{keysCheckSettings[indexPosition] ? keysCheckSettings[indexPosition] : 'Selesai'}}</h5> -->
				<!-- <div class="row text-center">
					<div class="col-xs-2 mt-auto mb-auto">
						<h6>Nama Barang</h6>
					</div>
					<div class="col-xs-2 mt-auto mb-auto">
						<h6>Ada, Kondisi Oke</h6>
					</div>
					<div class="col-xs-2 mt-auto mb-auto">
						<h6>Ada, Rusak</h6>
					</div>
					<div class="col-xs-2 mt-auto mb-auto">
						<h6>Tidak Ada</h6>
					</div>
					<div class="col-xs-4 mt-auto mb-auto">
						<h6>Gambar Barang</h6>
					</div>
				</div> -->
				<template >
					<div class="row pl-2" style="" :key="checklist.name">

						<div class="col-xs-12 col-lg-4 text-center mt-2">
							<div 
								class="rounded bg-white p-20 h-100" 
								:class="{'Selected' : checkSettings[checklist.variable].condition != '' , 'bg-warning-highlight' : highlight && !checkSettings[checklist.variable].condition}" 
							>
								<!-- <h5>{{data.condition.checklist[checklist.variable] ? data.condition.checklist[checklist.variable].condition : 'Belum Terpilih'}}</h5> -->
								<img :src="checklist.img" class="img-fluid" style="width:60%;height:auto" alt="Tidak ada Gambar"/>
								<h5>{{checklist.name}}</h5>
							</div>
						</div>

						<!-- <div class="col-xs-2 flex-center">
							{{checkSettings.condition}}
								<input type="radio" class="form-check-input" :value="'Ada, Kondisi Oke'" v-model="checkSettings[checklist.variable].condition"  />
						</div>
						<div class="col-xs-2 flex-center">
							<input type="radio" class="form-check-input" :value="'Ada, Rusak'" v-model="checkSettings[checklist.variable].condition"  />
							
						</div>
						<div class="col-xs-2 flex-center">
							<input type="radio" class="form-check-input" :value="'Tidak Ada'" v-model="checkSettings[checklist.variable].condition"  />
						</div> -->
						<div class="col-xs-12 col-lg-4 mt-2">
							<div class="rounded bg-white p-20 text-left h-100">
								<h5>Pilih Yang Sesuai</h5>

								<div class="border rounded mt-3 pl-3 pr-3" style="border-color:#348fe2!important" :class="{'highlight' : checkSettings[checklist.variable].condition == 'Ada, Kondisi Oke'}" @click="checkSettings[checklist.variable].condition = 'Ada, Kondisi Oke'">
									<div class="row pl-1 pr-1 pt-1 pb-1" >
										<div class="col-2 mt-1">
											<input type="radio" :value="'Ada, Kondisi Oke'" v-model="checkSettings[checklist.variable].condition" style="height:20px;width:100%" />
											<!-- <input type="radio" class="form-check-input" :value="'Ada, Kondisi Oke'" v-model="checkSettings[checklist.variable].condition"  /> -->
										</div>
										<div class="col-9">
											<span style="font-size:16px">Ada, Kondisi Barang Baik</span>
										</div>
									</div>
								</div>
								<div class="border rounded mt-3 " style="border-color:#348fe2!important" :class="{'highlight' : checkSettings[checklist.variable].condition == 'Ada, Rusak'}" @click="checkSettings[checklist.variable].condition = 'Ada, Rusak'">
									<div class="row pl-3 pr-3" >
										<div class="col-2 mt-1 pl-1 pr-1 pt-1 pb-1">
											<input type="radio" :value="'Ada, Rusak'" v-model="checkSettings[checklist.variable].condition" style="height:20px;width:100%" />
											<!-- <input type="radio" class="form-check-input" :value="'Ada, Kondisi Oke'" v-model="checkSettings[checklist.variable].condition"  /> -->
										</div>
										<div class="col-9 pl-1 pr-1 pt-1 pb-1">
											<span style="font-size:16px">Ada, Kondisi Barang Rusak</span>
										</div>
									</div>
									<div v-if="checkSettings[checklist.variable].condition == 'Ada, Rusak'" class="bg-white pl-2 pr-2 rounded">
										<input type="text" v-model="checkSettings[checklist.variable].desc" placeholder="Berikan Deskripsi Kerusakan Disini" style="height:35px;" />
									</div>
								</div>
								<div class="border rounded mt-3 pl-3 pr-3" style="border-color:#348fe2!important" :class="{'highlight' : checkSettings[checklist.variable].condition == 'Tidak Ada'}" @click="checkSettings[checklist.variable].condition = 'Tidak Ada'">
									<div class="row pl-1 pr-1 pt-1 pb-1" >
										<div class="col-2 mt-1">
											<input type="radio" :value="'Tidak Ada'" v-model="checkSettings[checklist.variable].condition" style="height:20px;width:100%" />
											<!-- <input type="radio" class="form-check-input" :value="'Ada, Kondisi Oke'" v-model="checkSettings[checklist.variable].condition"  /> -->
										</div>
										<div class="col-9">
											<span style="font-size:16px">Tidak Ada</span>
										</div>
									</div>
								</div>
								
							</div>
						</div>
						<div class="col-xs-12 col-lg-4 mt-2 text-center">
							<div class="rounded bg-white p-20 h-100">
								<div class="border border-secondary rounded h-100 align-middle"  @drop.prevent="validateSize($event, checklist.variable)" @dragover.prevent>
									<div style="color:#ccc" class="mt-3 mb-3">
										<img src="@/assets/img/UploadLogo.png" />
										<br>
										<br>
										<span>Drop Files Here</span>
										<br>
										<span>Or</span>
										<br>
										<br>
										<input type="file" class="btn btn-secondary w-75" @change="validateSize($event, checklist.variable)" placeholder="Select Files" multiple>
									</div>
								</div>
								<!-- {{checkSettings[checklist.variable]}} -->
							</div>
							
						</div>
						<div class="col-xs-12 mt-3" v-if="checkSettings[checklist.variable].img && checkSettings[checklist.variable].img.length > 0">
							<div class="rounded bg-white p-20 h-100">
								<h5>Gambar yang Diunggah</h5>
								<div class="row mt-1">
									<div class="col-3 text-center" style="max-height:150px" v-for="img in checkSettings[checklist.variable].img">
										<img :src="env.baseImage + '/' + img" class="h-100 w-auto"/>
									</div>
								</div>
							</div>
						</div>

						
					</div>

				</template>



				<!-- <div  class="w-100 testimonial-group" v-if="indexPosition <= 6">
					<div class="row mt-2 ml-2"  >
						<div class="col-xs-3 mt-2 p-3 text-center " v-for="checklist in checkSettingsFormatted[keysCheckSettings[indexPosition]]" :key="checklist.name"  >
							<div 
								class="border border-secondary rounded" 
								:class="{'Selected' : checkSettings[checklist.variable]}" 
							>
								<h5>{{data.condition.checklist[checklist.variable] ? data.condition.checklist[checklist.variable].condition : 'Belum Terpilih'}}</h5>
								<img :src="checklist.img" class="img-fluid" style="width:60%;height:auto" alt="Tidak ada Gambar"/>
								<h5>{{checklist.name}}</h5>
							</div>
						</div>
					</div>
				</div> -->

				

			

				

			</div>
			
		</b-card>

		<div class="mt-4 row">
			<div class="col-6 offset-md-6 col-md-3">
				<button class="btn btn-outline-warning w-100" @click="moveBackward">Posisi Sebelumnya</button>
			</div>
			<div class="col-6 col-md-3">
				<button class="btn btn-outline-primary w-100"  @click="moveForward">Posisi Berikutnya</button>
			</div>
		</div>

		<br>

		<!-- <div class="row">
			<div class="col-md-4">

			</div>
			<div class="col-md-8">
				<Datepicker style="padding-left:0;" :disabledDates="disabledDates" class="estimasi" :format="customFormatter" bootstrap-styling v-model="data.finishDate"></Datepicker>
			</div>
		</div> -->

		<!-- <div class="row" >
			<div class="col-md-6 col-0">
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-danger w-100 rounded" @click="$emit('backPage');">Sebelumnya</button>
			</div>
			<div class="col-md-3 col-6" >
				<button type="button" class="btn btn-success w-100 rounded" @click="showPrintTT" :disabled="!done || apiLoading">
					<span v-if="!apiLoading">Selesai</span>
					<template v-else>
						<span class="spinner-grow spinner-grow-sm"></span>
						Loading..
					</template>
				</button>
			</div>
		</div> -->

		<modalUploadImage :varHeader="partHeader" :var="part" :part="translatePart(part)" @showModalFalse="showModal = false" v-if="showModal" @uploadImage="uploadImage"/>
		<modalUploadImageCheckList :variable="part" @showModalFalse="showCheckListModal = false" v-if="showCheckListModal" @uploadImage="modalUploadImageCheckList"/>
		

		<transition name="modal" v-if="modal.printTT">
			<div class="modal-mask">
				<div class="modal-wrapper">
					<div class="row">
						<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
						<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

							<div class="modal-header row others" style="justify-content: flex-end;">
							<div class="col">
								<button type="button" class="close" @click="modal.printTT = false;">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							</div>


							<div class="modal-body" style="min-height:350px">
							
							<print-work-order
									v-if="modal.printTT"
									@tandaTangan="modal.tandaTangan = true;modal.printTT = false"
									@closeModal="modal.printTT = false"
									:data="altData"
									@Done="print=1;modal.printTT = false"
									:complete="true"
									:title="'Konfirmasi Tanda Terima Mobil'"
									:checklistSettings="checkSettings"
								></print-work-order>

							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
			</div>
			</div>
		</transition>

		<transition name="modal" v-if="modal.tandaTangan">
			<div class="modal-mask">
				<div class="modal-wrapper">
					<div class="row">
						<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
						<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

							<div class="modal-header row others" style="justify-content: flex-end;">
							<div class="col">
								<button type="button" class="close" @click="modal.printTT = false;">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							</div>


							<div class="modal-body" style="min-height:350px">
								<div class="w-100 input-group">
									<label class="label text-left">Tanda Tangan Customer</label>
									
									<!-- <button class="btn btn-danger mt-2" @click="undo">Reset</button> -->
								</div>
								<div class="row">
									<div class="col-12 col-md-6">
										<VueSignaturePad width="100%" height="300px" class="border border-secondary" ref="signaturePad" />
										<button class="btn btn-danger mt-2" @click="$refs.signaturePad.undoSignature();">Reset</button>
									</div>
									
								</div>

								<div class="text-center">
									<button class="btn btn-md btn-primary" style="width:150px" @click="submit">Save Signature</button>
									<button class="btn btn-md btn-danger ml-3" style="width:150px" @click="modal.tandaTangan = false;modal.printTT = true">Cancel</button>
								</div>

							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
			</div>
			</div>
		</transition>
		
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import modalUploadImage from './modalUploadImage'
	import moment from 'moment'
	import modalUploadImageCheckList from './modalUploadImageChecklist.vue'
	import printWorkOrder from './../children/printWorkOrder'
	import env from '@/env'
	import Datepicker from 'vuejs-datepicker'
	export default {
		components: {
			Multiselect,
			modalUploadImage,
			modalUploadImageCheckList,
			printWorkOrder,
			Datepicker
		},
		data () {
			return {
				env,
				modal : {
					printTT : false,
					tandaTangan : false
				},
				user : this.$store.state.userData.userData,
				print : 0,
				altData : null,
				mobile : this.isMobile(),
				done : false,
				indexPosition : 0,
				currPosition : 0,
				showModal: false,
				part: '',
				partHeader : '',
				showFrontModal: false,
				carTypes : this.carType,
				checkSettings : this.data.condition.checklist,
				checkSettingsFormatted : null,
				showCheckListModal : false,
				keysCheckSettings : null,
				move : null,
				highlight : false,
				disabledDates: {
					to: new Date(new moment().format("Y-MM-DD"))
				},
				keySelector : 'BARANG'
			}
		},
		watch : {
			keySelector : function () {
				// console.log(this.keysCheckSettings)

				let indexTo = this.keysCheckSettings.indexOf(this.keySelector)
				let indexFrom = this.indexPosition

				if(indexTo >= indexFrom) {
					for(var i = indexFrom ; i < indexTo ; i++) {
						if(!this.allowMoveForward(i)){
							this.$nextTick(() => this.keySelector = this.keysCheckSettings[indexFrom])
							return
						}
							
					}
				}

				this.indexPosition = indexTo
				
			},
			indexPosition : function () {
				this.currPosition = 0
				if(this.indexPosition == 7){
					this.done = true
					this.showPrintTT()
					return
				}
					

				if(this.checkSettingsFormatted[this.keysCheckSettings[this.indexPosition]].length <= 0) {
					if(this.move == 'forward')
						this.indexPosition++;
					else
						this.indexPosition--;
				}
			},
			'modal.printTT' : function() {
				if(this.print)
					this.nextPage()
			}
		},
		props: ['page', 'data', 'checklistSettings' , 'carType', 'title', 'apiLoading', 'skip'],
		mounted () {

			this.altData = JSON.parse(JSON.stringify(this.data))
			// console.log(this.altData)
			this.altData.condition.figure = this.altData.condition.figure[this.carType]
			this.altData.condition.figureOverall = this.altData.condition.figureOverall[this.carType]
			this.altData.customer_car.customer = this.altData.customer
			this.seperate()

			// let keys = Object.keys(this.checkSettings)

			// for(var i = 0 ; i < keys.length ; i++) {
			// 	this.$set(this.checkSettings, keys[i], {
			// 		condition : 'Ada, Kondisi Oke',
			// 		image : null,
			// 		desc : ''
			// 	})
			// }
		},
		methods: {
			async validateSize(data , variable) {

				let file = data.dataTransfer ? data.dataTransfer.files : data.target.files;
				// console.log(file)

				let images = await this.uploadAllImage(file)
				if(this.checkSettings[variable].img)
					this.checkSettings[variable].img.concat(images)
				else 
					this.checkSettings[variable].img = images
			},
			async uploadAllImage(file) {
				let image = []
				let url = env.urlStart + "/api/v1/workorder/image"
				for(var i = 0 ; i < file.length ;  i++) {
					let formData = new FormData()

					formData.append('work_order' , file[i])
					
					let response = await this.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
					image.push(response.data.data.filename)
				}
				
				return image
				
			},
			async submit() {
				this.modal.tandaTangan = false
				let { isEmpty , data } = this.$refs.signaturePad.saveSignature()

				if(isEmpty) {
					
					this.data.condition.ttdCustomer = ''
					// console.log(this.data.condition.ttdCustomer)
					this.data.check_by = this.$store.state.userData.userData.name
					this.showPrintTT()
					return
				}

				this.data.condition.ttdCustomer = await this.submitPic(data);
				this.altData.condition.ttdCustomer = this.data.condition.ttdCustomer
				this.altData.condition.checklist = this.data.condition.checklist
				this.altData.CSO = this.user.name
				if(this.data.condition.ttdCustomer == 'Error') return
				this.data.check_by = this.$store.state.userData.userData.name
				this.showPrintTT()
			},
			async submitPic(image) {
				try {
					let formData = new FormData()

					let data = await fetch(image).then(function(res){return res.arrayBuffer();}).then(function(buf){return new File([buf], 'ttdImage.png',{type:'image/png'});})
					formData.append('image' , data)

					let response = await this.$http.post(env.urlStart + '/api/v1/workorder/steps/upload' , formData , {headers : {"Content-Type":'multipart/form-data'}})
					
					return response.data.data.filename
				}
				catch(err) {
					this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong When Uploading Image'])
					console.log(err)
					return 'Error'
				}
			},
			allowMoveForward(index) {
				let keys = Object.keys(this.checkSettings)
				let mapSearch = this.checkSettingsFormatted[this.keysCheckSettings[index]].map(x => x.variable)
				for(var i = 0 ; i < keys.length ; i++) {
					// if(keys == this.checkSettingsFormatted[keysCheckSettings[this.indexPosition]].variable) {

					// }

					if(mapSearch.includes(keys[i])) {
						// console.log(mapSearch , keys[i] , this.checkSettings[keys[i]])
						let condition = this.checkSettings[keys[i]].condition
						let desc = this.checkSettings[keys[i]].desc
						// console.log(condition)
						if(condition == ''){
							this.highlight = true
							this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi Semua Kondisi Barang'])
							return false
						}
						else if (condition == 'Ada, Rusak' && desc == '') {
							this.highlight = true
							this.$store.dispatch('triggerAlert' , [false , 'Mohon Diisi Deskripsi Untuk Kondisi Barang Rusak'])
							return false
						}
					}
				}
				return true
			},
			moveForward () {
				if(this.allowMoveForward(this.indexPosition)) {
					this.highlight = false
					this.move = 'forward'
					this.indexPosition++
					this.$nextTick(() => this.keySelector = this.keysCheckSettings[this.indexPosition])
					// scrollIntoView('#typeOfCar')
					// Element.scrollIntoView('#typeOfCar')
					this.$refs['typeOfCar'].scrollIntoView({ behavior: 'smooth' });
				}
			},
			moveBackward () {
				this.move = 'backward'
				if(this.indexPosition - 1 < 0) {
					this.$emit('backPage')
				}
				this.indexPosition--
				this.keySelector = this.keysCheckSettings[this.indexPosition]
				// Element.scrollIntoView('#typeOfCar')
				this.$refs['typeOfCar'].scrollIntoView({ behavior: 'smooth' });
			},
			showPrintTT () {
				if(this.skip) {
					this.nextPage()
					return
				}
				this.modal.printTT = true
			},
			seperate () {
				let list = this.checklistSettings
				// console.log(list)

				let newList = {
					'BARANG' : [] , 
					'INTERIOR' : [],
					'FRONT' : [] , 
					'REAR' : [] , 
					'LEFT' : [] , 
					'RIGHT' : [] , 
					'ATAP' : [], 
				}

				for(var i = 0 ; i < list.length ; i ++) {
					let location  = list[i].name.split('_')[0]
					let obj = {
						img : list[i].img ? env.baseImage + '/' + list[i].img :  '/img/WorkOrder/Logo/' + list[i].name.split("_")[1] + '.png',
						name : list[i].name.split("_")[1],
						variable : list[i].name
					}

					newList[location].push(obj)
					// console.log(newList)

				}
				this.checkSettingsFormatted = newList
				this.keysCheckSettings = Object.keys(this.checkSettingsFormatted)
				this.keysCheckSettings.push('SELESAI')

			},
			checked(part) {
				// console.log(part)
				if(this.checkSettings[part].img){

				
					this.$swal.fire({
						title: 'Apakah anda yakin?',
						text : 'Semua Gambar akan dihapus',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Saya Yakin',
						cancelButtonText: 'Kembali'
					}).then((result)=>{
						if(result.value){
							this.checkSettings[part].img = null
						}
					})
				}
					
				else {
					this.showCheckListModal = true
					this.part = part
				}
			},
			selectPart (part , carType) {

				let partString = part.split('.')
				
				

				
				if(this.data.condition.figure[carType][partString[0]][partString[1]]  && this.data.condition.figure[carTypes][partString[0]][partString[1]] != true ) {
					this.$swal.fire({
						title: 'Apakah anda yakin?',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Saya Yakin',
						cancelButtonText: 'Kembali'
					}).then((result)=>{
						if(result.value){
							this.data.condition.figure[carTypes][partString[0]][partString[1]] = false
						}
					})
				}
				else {
					this.showModal = true
					this.part = partString[1]
					this.partHeader = 'figure'
				}
			},
			uploadImage (partHeader , part, url) {
				if(partHeader != 'figureOverall')
					this.data.condition[partHeader][this.carType].right[part] = url
				else 
					this.data.condition[partHeader][this.carType][part] = url
				// alert("Unggah Gambar Berhasil!")
				this.$store.dispatch('triggerAlert', [true, ['Unggah Gambar Berhasil']])
				
				this.showModal = false

				if(partHeader == 'figureOverall')
					this.createWorkOrder()
			},
			translatePart (str) {
				let strSplit = str.split("_").reverse()

				for (var i = 0 ; i < strSplit.length ; i ++) {
					
					if(strSplit[i] == 'front')
						strSplit[i] = 'depan'
					else if (strSplit[i] == 'rear')
						strSplit[i] = 'belakang'
					else if (strSplit[i] == 'left')
						strSplit[i] = 'kiri'
					else if (strSplit[i] == 'right')
						strSplit[i] = 'kanan'
					else if (strSplit[i] == 'wheel')
						strSplit[i] = 'roda'
					else if (strSplit[i] == 'door')
						strSplit[i] = 'pintu'
					else if (strSplit[i] == 'light')
						strSplit[i] = 'lampu'

					strSplit[i] = strSplit[i].charAt(0).toUpperCase() + strSplit[i].slice(1)
				}

				return strSplit.join(" ")
			},
			nextPage () {
				this.$emit('nextPage' , null)
			}
		}
	}
</script>


<style scoped>
	.testimonial-group > .row {
		overflow-x: auto;
		flex-wrap: nowrap;
	}
	.testimonial-group > .row > .col-xs-3 {
		display: inline-block;
		float: none;
	}
</style>

<style scoped>
	.color-green {
		color : #29BC53;
	}
	.color-blue {
		color : #007ED9;
	}
	.color-yellow {
		color : #FFDD05;
	}
	.color-red {
		color : #FF0000;
	}

	.btn {
		border-radius: 30px;
		border : 0.5px solid;
	}

	.btn-green {
		background-color: #29BC5326;
		color : black;
	}

	.btn-blue {
		background-color: #007ED926;
		color : black;
	}
	.btn-yellow {
		background-color: #FFDD0526;
		color : black;
	}
	.btn-red {
		background-color: #FF000026;
		color : black;
	}

	.label-car-type {
		letter-spacing: 0.015em;
		font-size: 14px;
	}

	.highlight {
		background-color : #348fe2!important;
		color:white;
	}
</style>

<style scoped>
/* The container */
.container {
  /* display: block; */
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
 	top: 9px;
	left: 9px;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: white;
}
.flex-center {
	display : flex;
	justify-content: center;
	align-items: center;
}

.form-check-input {
	margin: 0;
	font-size: 18px;
	width : 100%;
	height: 20px;
}

.bg-warning-highlight {
	background-color: #fff2ba!important;
}
</style>